import { formatFacetName, pushAnalyticsObjToDataLayer } from "@/utils/helper"
import { getAppliedFiltersForAnalytics } from "@/components/ProductList/v2/Filter/helper"
import { LITERATURE, TECHNICAL_SPECIFICATIONS } from "@/constants/index"
import {
  FILTER,
  HELP_AND_FAQ,
  SEARCH_RESULTS,
  TECHNICAL_SPECS,
} from "@/components/ProductList/v2/Filter/analytics/constants"

const getShowHideFilterOptionAnalyticsData = (
  collapseState,
  facetName,
  page,
  selectedTab = "products"
) => {
  let eventInfo = {
    eventAction: `plp filter ${
      collapseState ? FILTER.EXPAND : FILTER.COLLAPSE
    }`,
    eventName: `plp filter ${collapseState ? FILTER.EXPAND : FILTER.COLLAPSE}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: collapseState ? FILTER.EXPAND : FILTER.COLLAPSE,
    internalLinkPosition: "plp",
    internalLinkType: "plp:" + facetName,
    internalLinkZoneName: "plp:filters",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (page === "search") {
    eventInfo = {
      eventAction: `search results:${selectedTab}:filters ${
        collapseState ? FILTER.EXPAND : FILTER.COLLAPSE
      }`,
      eventName: `search results:${selectedTab}:filters ${
        collapseState ? FILTER.EXPAND : FILTER.COLLAPSE
      }`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: collapseState ? FILTER.EXPAND : FILTER.COLLAPSE,
      internalLinkPosition: "search results",
      internalLinkType: "search results:" + facetName,
      internalLinkZoneName: `search results:${selectedTab}:filters`,
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
  } else if (page === "literature") {
    eventInfo = {
      eventAction: `literature :filters ${
        collapseState ? FILTER.EXPAND : FILTER.COLLAPSE
      }`,
      eventName: `literature :filters ${
        collapseState ? FILTER.EXPAND : FILTER.COLLAPSE
      }`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: collapseState ? FILTER.EXPAND : FILTER.COLLAPSE,
      internalLinkPosition: "literature",
      internalLinkType: "literature:" + facetName,
      internalLinkZoneName: `literature :filters`,
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
  } else if (page === "article") {
    eventInfo = {
      eventAction: `${HELP_AND_FAQ}:filters ${
        collapseState ? FILTER.EXPAND : FILTER.COLLAPSE
      }`,
      eventName: `${HELP_AND_FAQ}:filters ${
        collapseState ? FILTER.EXPAND : FILTER.COLLAPSE
      }`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: collapseState ? FILTER.EXPAND : FILTER.COLLAPSE,
      internalLinkPosition: HELP_AND_FAQ,
      internalLinkType: `${HELP_AND_FAQ}:` + facetName,
      internalLinkZoneName: `${HELP_AND_FAQ}:filters`,
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
  }

  return eventInfo
}

const getFilterOptionsAnalyticsData = ({
  obj,
  appliedFilters,
  facetLabels,
  facetName,
  isSelected,
  page,
  selectedTab,
}) => {
  const getAppliedFiltersForPlpAnalyticsData = objDisplay => {
    const dataLayerFilterArray = []
    appliedFilters.forEach(filter => {
      filter.display.forEach(filtervalue => {
        dataLayerFilterArray.push(
          `${formatFacetName(filter.facet, null, facetLabels)}:${filtervalue}`
        )
      })
    })
    const myIndex = dataLayerFilterArray.indexOf(`${facetName}:${objDisplay}`)
    if (myIndex !== -1) {
      dataLayerFilterArray.splice(myIndex, 1)
    } else {
      dataLayerFilterArray.push(`${facetName}:${objDisplay}`)
    }
    return dataLayerFilterArray.length ? dataLayerFilterArray.join("|") : ""
  }

  const plpFilterArrayData = getAppliedFiltersForPlpAnalyticsData(obj.display)

  let analyticsData = ""

  const appliedOrRemoved = isSelected(obj) ? "removed" : "applied"

  if (page === "search") {
    analyticsData = JSON.stringify({
      eventAction: `search results:${selectedTab}:filters ${
        isSelected(obj) ? "removed" : "applied"
      }`,
      eventName: `search results:${selectedTab}:filters ${
        isSelected(obj) ? "removed" : "applied"
      }`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: `${obj.display}`,
      internalLinkPosition: "search results",
      internalLinkType: `search results:${facetName}`,
      internalLinkZoneName: `search results:${selectedTab}:filters`,
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
      filterArray: plpFilterArrayData,
    })
  } else if (page === "technicalspecs") {
    analyticsData = JSON.stringify({
      eventAction: `technical specs:filters ${appliedOrRemoved.toLowerCase()}`,
      eventName: `technical specs:filters ${appliedOrRemoved.toLowerCase()}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: `${obj.display.toLowerCase()}:${appliedOrRemoved.toLowerCase()}`,
      internalLinkPosition: "technical specs",
      internalLinkType: `technical specs:${facetName.toLowerCase()}`,
      internalLinkZoneName: "technical specs:filters",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
      filterArray: plpFilterArrayData,
    })
  } else if (page === "article") {
    analyticsData = JSON.stringify({
      eventAction: `support:help and faq:filters:filter ${appliedOrRemoved}`,
      eventName: `support:help and faq:filters:filter ${appliedOrRemoved}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: `${obj.display}:${appliedOrRemoved}`,
      internalLinkPosition: "knowledge articles",
      internalLinkType: `support:help and faq:${facetName}`,
      internalLinkZoneName: "support:help and faq:filters",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
      filterArray: plpFilterArrayData,
    })
  } else if (page === LITERATURE) {
    analyticsData = JSON.stringify({
      eventAction: `${LITERATURE}:filters ${
        isSelected(obj) ? "removed" : "applied"
      }`,
      eventName: `${LITERATURE}:filters ${
        isSelected(obj) ? "removed" : "applied"
      }`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: `${obj.display.toLowerCase()}:${
        isSelected(obj) ? "removed" : "applied"
      }`,
      internalLinkPosition: LITERATURE,
      internalLinkType: `${LITERATURE}:${facetName.toLowerCase()}`,
      internalLinkZoneName: `${LITERATURE}:filters`,
      internalLinkURL: window.location.href,
      clickInternalLinks: "true",
      filterArray: plpFilterArrayData.toLowerCase(),
    })
  } else {
    analyticsData = JSON.stringify({
      eventAction: `plp filter ${isSelected(obj) ? "removed" : "applied"}`,
      eventName: `plp filter ${isSelected(obj) ? "removed" : "applied"}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: `${obj.display}`,
      internalLinkPosition: "plp",
      internalLinkType: `plp:${facetName}`,
      internalLinkZoneName: "plp:filters",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
      filterArray: `${plpFilterArrayData}`,
    })
  }

  return analyticsData
}

export const addFilterCancelDataLayerOnClick = (
  value,
  appliedFilters,
  facet,
  filter,
  selectedTab,
  page,
  facetLabels = []
) => {
  const filterArrayList = getAppliedFiltersForPlpAnalyticsData(
    appliedFilters,
    facet.facet,
    filter,
    facetLabels
  )
  let type = "plp filter "
  let internalLinkPosition = "plp"
  let internalValue = "plp"
  let internalLinkName = filter
  if (page === "article") {
    type = "support:help and faq:filters:"
    internalLinkPosition = "knowledge articles"
    internalValue = "support:help and faq"
    internalLinkName = `${filter}:removed`
  } else if (page === "search") {
    type = `search results:${selectedTab}:filters `
    internalLinkPosition = "search results"
    internalValue = `search results:${selectedTab}`
  } else if (page === "technicalspecs") {
    type = "technical specs:filter "
    internalLinkPosition = "technical specs"
    internalValue = "technical specs"
    internalLinkName = `${filter}:removed`
  } else if (page === LITERATURE) {
    type = `${LITERATURE}:filter `
    internalLinkPosition = LITERATURE
    internalValue = LITERATURE
    internalLinkName = `${filter}:cancel`
  }
  const eventValue = `${type}${value}`.toLowerCase()
  const eventInfo = {
    eventAction: eventValue,
    eventName: eventValue,
    eventType: "navigation",
    filterArray: filterArrayList,
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: internalLinkName.toLowerCase(),
    internalLinkPosition: internalLinkPosition.toLowerCase(),
    internalLinkType: `${internalValue}:${formatFacetName(
      facet["facet"],
      null,
      facetLabels
    )}`.toLowerCase(),
    internalLinkZoneName: `${internalValue}:filters`.toLowerCase(),
    internalLinkURL: window.location.href,
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

const getAppliedFiltersForPlpAnalyticsData = (
  appliedFilters,
  facet,
  obj,
  facetLabels = []
) => {
  const dataLayerFilterArray = []
  appliedFilters.forEach(filter => {
    filter.display.forEach(filtervalue => {
      dataLayerFilterArray.push(
        `${formatFacetName(
          filter.facet,
          null,
          facetLabels
        )}:${filtervalue}`.toLowerCase()
      )
    })
  })
  const myIndex = dataLayerFilterArray.indexOf(
    `${formatFacetName(facet, null, facetLabels)}:${obj}`.toLowerCase()
  )
  if (myIndex !== -1) {
    dataLayerFilterArray.splice(myIndex, 1)
  } else {
    dataLayerFilterArray.push(
      `${formatFacetName(facet, null, facetLabels)}:${obj}`.toLowerCase()
    )
  }
  return dataLayerFilterArray.length ? dataLayerFilterArray.join("|") : ""
}

const getFilterClearAllAnalyticsData = (sectionTab, page) => {
  let analyticsData = {
    eventAction: "plp clear all filter",
    eventName: "plp clear all filter",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "clear all",
    internalLinkPosition: "plp",
    internalLinkType: "plp:clear all",
    internalLinkZoneName: "plp:filters",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (page === "article") {
    analyticsData = {
      eventAction: "support:help and faq:filters​:clear all",
      eventName: "support:help and faq:filters​:clear all",
      eventType: "informative",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: "clear all",
      internalLinkPosition: "knowledge articles",
      internalLinkType: "support:help and faq:navigation",
      internalLinkZoneName: "support:help and faq:filters​​",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
  }
  if (page === "search") {
    analyticsData = {
      clickInternalLinks: "true",
      eventAction: `search results:${sectionTab}:clear all`,
      eventName: `search results:${sectionTab}:clear all`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: "clear all",
      internalLinkPosition: "search results",
      internalLinkType: "search results:clear all",
      internalLinkURL: "n/a",
      internalLinkZoneName: `search results:${sectionTab}:filters`,
    }
  }
  if (page === "literature") {
    analyticsData = {
      clickInternalLinks: "true",
      eventAction: `literature:filters:clear all`,
      eventName: `literature:filters:clear all`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: "clear all",
      internalLinkPosition: "literature",
      internalLinkType: "literature:clear all",
      internalLinkURL: "n/a",
      internalLinkZoneName: `literature:filters`,
    }
  }
  if (page === "technicalspecs") {
    analyticsData = {
      clickInternalLinks: "true",
      eventAction: `${TECHNICAL_SPECIFICATIONS}:filters:clear all`,
      eventName: `${TECHNICAL_SPECIFICATIONS}:filters:clear all`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: "clear all",
      internalLinkPosition: TECHNICAL_SPECIFICATIONS,
      internalLinkType: `${TECHNICAL_SPECIFICATIONS}:clear all`,
      internalLinkURL: "n/a",
      internalLinkZoneName: `${TECHNICAL_SPECIFICATIONS}:filters`,
    }
  }

  return JSON.stringify(analyticsData)
}

const getAnalyticsData = (isSelected, page) => {
  const technicalSpecs = page === "technicalspecs"
  const hideDiscontinuedEventObj = {
    eventAction: technicalSpecs
      ? `${TECHNICAL_SPECS}:${FILTER.FILTERS}:${FILTER.HIDE_DISCONTINUED}`
      : `${SEARCH_RESULTS}:${FILTER.FILTERS}:${FILTER.HIDE_DISCONTINUED}`,
    eventName: technicalSpecs
      ? `${TECHNICAL_SPECS}:${FILTER.FILTERS}:${FILTER.HIDE_DISCONTINUED}`
      : `${SEARCH_RESULTS}:${FILTER.FILTERS}:${FILTER.HIDE_DISCONTINUED}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${FILTER.HIDE_DISCONTINUED}:${
      isSelected ? "checked" : "unchecked"
    }`,
    internalLinkPosition: technicalSpecs ? TECHNICAL_SPECS : "search results",
    internalLinkType: technicalSpecs
      ? `${TECHNICAL_SPECS}:checkbox`
      : "search results:checkbox",
    internalLinkZoneName: technicalSpecs
      ? `${TECHNICAL_SPECS}:${FILTER.FILTERS}`
      : `${SEARCH_RESULTS}:${FILTER.FILTERS}`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  return JSON.stringify(hideDiscontinuedEventObj)
}

const getPrintOrShareEventInfo = (printOrShare, selectedTab, page) => {
  let eventInfo = ""

  if (page === "search") {
    eventInfo = {
      eventAction: `search results:${selectedTab}:filters:${printOrShare}`,
      eventName: `search results:${selectedTab}:filters:${printOrShare}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: printOrShare,
      internalLinkPosition: "search results",
      internalLinkType: `search results:${printOrShare}`,
      internalLinkZoneName: `search results:${selectedTab}:filters`,
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
  } else if (page === "technicalspecs") {
    eventInfo = {
      eventAction: `technical specs:filters:${printOrShare}`,
      eventName: `technical specs:filters:${printOrShare}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: printOrShare,
      internalLinkPosition: "tech specs",
      internalLinkType: `technical specs:${printOrShare}`,
      internalLinkZoneName: "technical specs:filters​",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
  } else if (page === "literature") {
    eventInfo = {
      eventAction: `literature:filters:${printOrShare}`,
      eventName: `literature:filters:${printOrShare}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: printOrShare,
      internalLinkPosition: "literature",
      internalLinkType: `literature:${printOrShare}`,
      internalLinkZoneName: `literature:filters`,
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
  } else if (page === "article") {
    eventInfo = {
      eventAction: `${HELP_AND_FAQ}:${printOrShare}`,
      eventName: `${HELP_AND_FAQ}:${printOrShare}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: printOrShare,
      internalLinkPosition: HELP_AND_FAQ,
      internalLinkType: `${HELP_AND_FAQ}:${printOrShare}`,
      internalLinkZoneName: `${HELP_AND_FAQ}:filters`,
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
  } else {
    eventInfo = {
      eventAction: `plp ${printOrShare}`,
      eventName: `plp ${printOrShare}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: printOrShare,
      internalLinkPosition: "plp",
      internalLinkType: `plp:print`,
      internalLinkZoneName: "plp:filters",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
  }

  return eventInfo
}

const getFilterCloseAnalyticsData = page => {
  let analyticsData = ""
  if (page === "article") {
    analyticsData =
      '{"eventAction":"support:help and faq:filters​:close","eventName":"support:help and faq:filters​:close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close(x)","internalLinkPosition":"knowledge articles","internalLinkType":"support:help and faq:close","internalLinkZoneName":"support:help and faq:filters​","internalLinkURL":"n/a","clickInternalLinks":"true"}'
  } else {
    analyticsData =
      '{"eventAction":"plp filter close","eventName":"plp filter close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close","internalLinkPosition":"plp","internalLinkType":"plp:close","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true"}'
  }

  return analyticsData
}
const getFilterViewResultsAnalyticsData = (
  facetLabels,
  page,
  appliedFilters
) => {
  let analyticsData = ""
  if (page === "article") {
    analyticsData =
      '{"eventAction":"support:help and faq:filters​:view results","eventName":"support:help and faq:filters​:view results","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view results","internalLinkPosition":"knowledge articles","internalLinkType":"support:help and faq:navigation","internalLinkZoneName":"support:help and faq:filters​","internalLinkURL":"n/a","clickInternalLinks":"true"}'
  } else {
    analyticsData =
      '{"eventAction":"plp filter view result","eventName":"plp filter view result","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view result","internalLinkPosition":"plp","internalLinkType":"plp:filters","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true","filterArray":"' +
      getAppliedFiltersForAnalytics(appliedFilters, facetLabels) +
      '"}'
  }

  return analyticsData
}

const getFilterCloseImgAnalyticsData = () => {
  const analyticsData =
    '{"eventAction":"plp filter close","eventName":"plp filter close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close","internalLinkPosition":"close","internalLinkType":"plp:close","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true"}'

  return analyticsData
}
const getSocialShareAnalyticsData = (page, selectedTab) => {
  let analyticsData = ""
  if (page === "technicalspecs") {
    analyticsData = {
      eventAction: "technical specs:filters:share",
      eventName: "technical specs:filters:share",
      internalLinkPosition: "tech specs",
      internalLinkType: "technical specs​:share",
      internalLinkZoneName: "technical specs:filters",
    }
  } else if (page === "literature") {
    analyticsData = {
      eventAction: `${page}:filters:share`,
      eventName: `${page}:filters:share`,
      internalLinkPosition: page,
      internalLinkType: `${page}:share`,
      internalLinkZoneName: `${page}:filters`,
      eventType: "informative",
    }
  } else if (page === "search") {
    analyticsData = {
      eventAction: `search results:${selectedTab}:filters:share`,
      eventName: `search results:${selectedTab}:filters:share`,
      internalLinkPosition: "search results",
      internalLinkType: "search results:share",
      internalLinkZoneName: `search results:${selectedTab}:filters`,
    }
  } else if (page === "article") {
    analyticsData = {
      eventAction: `${HELP_AND_FAQ}:share`,
      eventName: `${HELP_AND_FAQ}:share`,
      internalLinkPosition: HELP_AND_FAQ,
      internalLinkType: `${HELP_AND_FAQ}:share`,
      internalLinkZoneName: `${HELP_AND_FAQ}:filters`,
      eventType: "informative",
    }
  } else {
    analyticsData = {
      eventAction: "plp product share",
      eventName: "plp product share",
      internalLinkPosition: "plp",
      internalLinkType: "plp:share",
      internalLinkZoneName: "plp:promo tiles",
      eventType: "navigation",
    }
  }

  return analyticsData
}

const addCollapseAnalytics = (state, facetName, page, selectedTab) => {
  const eventInfo = getShowHideFilterOptionAnalyticsData(
    state,
    facetName?.toLowerCase(),
    page,
    selectedTab
  )
  pushAnalyticsObjToDataLayer(eventInfo)
}
const addPrintOrShareAnalytics = (printOrShare, selectedTab, page) => {
  const eventInfo = getPrintOrShareEventInfo(printOrShare, selectedTab, page)
  pushAnalyticsObjToDataLayer(eventInfo)
}

export {
  getFilterOptionsAnalyticsData,
  getFilterClearAllAnalyticsData,
  getAnalyticsData,
  getFilterCloseAnalyticsData,
  getFilterCloseImgAnalyticsData,
  getFilterViewResultsAnalyticsData,
  getSocialShareAnalyticsData,
  addCollapseAnalytics,
  addPrintOrShareAnalytics,
}
